import { render, staticRenderFns } from "./SportIcons.vue?vue&type=template&id=82424b30"
import script from "./SportIcons.vue?vue&type=script&lang=ts"
export * from "./SportIcons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports